import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { usePermissions } from '@nucleus-commerce/admin-kit/permissions';

import { useDebouncedValue } from '@/shared/hooks/use-debounced-value';

import { conversationsApi } from '../api/conversations-api';
import { MIN_ARTICLE_QUERY } from '../lib/article-query';

import { conversationKeys } from './conversation-keys';

/** Help centre articles for the composer's `?` palette; members without help.read get none. */
export function useHelpArticleSearch(storeId: string, query: string | null) {
  const { can } = usePermissions();
  const q = useDebouncedValue((query ?? '').trim(), 250);
  const enabled = can('help.read') && query !== null && q.length >= MIN_ARTICLE_QUERY;
  return useQuery({
    queryKey: conversationKeys.helpArticles(storeId, q),
    queryFn: () => conversationsApi.helpArticles(storeId, q),
    enabled,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });
}
